export const errorAttachmentStatus = Object.freeze({
  CROSS_MUNICIPAL: 12,
  CROSS_MUNICIPAL_DOCUMENT: 13,
});
